// 번역 파일 통합 모듈
import enCommon from './en/common';
import enHome from './en/home';
import enNews from './en/news';
import enGallery from './en/gallery';
import enAbout from './en/about';

import koCommon from './ko/common';
import koHome from './ko/home';
import koNews from './ko/news';
import koGallery from './ko/gallery';
import koAbout from './ko/about';

// 영어 번역 통합
const en = {
  translation: {
    common: enCommon,
    home: enHome,
    news: enNews,
    gallery: enGallery,
    about: enAbout
  }
};

// 한국어 번역 통합
const ko = {
  translation: {
    common: koCommon,
    home: koHome,
    news: koNews,
    gallery: koGallery,
    about: koAbout
  }
};

export default { en, ko };
